module.exports = __webpack_public_path__ + "static/media/chaos.43b046ad.jpg";